import GridTableBase from '../../../ui_components/gridTable/GridTable';
import GridTableBodyBase from '../../../ui_components/gridTable/GridTableBody';
import React, { PureComponent } from 'react';
import styled from '../../../theme';
import { FadeLoader } from 'react-spinners';
import SortTableRow from './sort_table_row';
import Accordion from '../accordion/Accordion';
import { IoIosArrowRoundDown } from 'react-icons/io';
import ArrowDown from '../../../assets/icons/chevron-down.svg';
import SearchSelect, { SearchSelectProps } from '../search_select/search_select';
import { DotMenuState } from '../../../pages/clients';

const Container = styled.div`
  /* ignore */
`;

const GridTable = styled(GridTableBase)`
`;

const GridTableBody = styled(GridTableBodyBase)`
  height: calc(100vh - 240px);
  overflow: auto;
`;

const TableHead = styled.div`
  background: #ffffff;
  color: #222222;
  font-weight: 500;
  border-bottom: 1px solid #e2e2e2;
  font-weight: 500;
  &:hover {
    cursor: pointer;
    background-color: #ecf6f9;
  }
`;

export interface SortTableRowInfo {
  id: number;
  active: boolean;
  avatarId?: string;
  displayName: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  email?: string;
  cellPhone?: string;
  homePhone?: string;
  officePhone?: string;
  subList?: SortTableRowInfo[];
  billToParent?: boolean;
  parent?: any;
  billingType?: string;
}

export interface ClientsTableProps {
  sort: { column: string; value: 'ASC' | 'DESC' };
  list: SortTableRowInfo[];
  scrollTop?: number;
  onSortingChanged(sort: 'ASC' | 'DESC', key: string): void;
  onRowChoosed(id: number, scrollTop?: number): void;
  isLoading?: boolean;
  onSearch: SearchSelectProps['onSearch'];
  onItemClick(id: number): void;
  handleShowDotMenu?(data: any): void;
  handleDotMenuAction?(action: string, data: any): void;
  dotMenu?: DotMenuState;
}

interface ClientsTableState {
  scrollWidth: number;
  activeIndexes: any[];
  isCollapsed: boolean;
}

export class ClientsTable extends PureComponent<ClientsTableProps, ClientsTableState> {
  public state = {
    scrollWidth: 0,
    activeIndexes: [],
    isCollapsed: true,
  };

  public componentDidMount() {
    window.addEventListener('resize', this.handleResize);

    const e = document.getElementById('grid-table-body');
    if (e && this.props.scrollTop) {
      e.scrollTop = this.props.scrollTop;
    }
    this.handleResize();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  public componentDidUpdate() {
    this.handleResize();
  }

  public handleToggleAll = () => {
    this.setState({
      activeIndexes: this.state.isCollapsed ? this.flattenItems(this.props.list) : [],
      isCollapsed: !this.state.isCollapsed,
    });
  };

  public flattenItems = (nodes: any[]): any[] => {
    const out: any[] = [];
    const walk = (arr: any[]) => {
      for (const n of arr) {
        out.push(n);
        if (n && n.subClients && n.subClients.length) walk(n.subClients);
      }
    };
    walk(nodes);
    return out;
  };

  public render(): JSX.Element {
    const { list, sort } = this.props;
    return (
      <Container>
        {this.props.isLoading ? (
          <FadeLoader
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(50%,-50%)',
              zIndex: 9999,
              display: !this.props.isLoading ? 'none' : 'block',
            }}
            color="#3B97B1"
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        ) : (
          <div>
            <div className="flex justify-end client_search_container">
              <SearchSelect
                searchType="header"
                onItemClick={this.props.onItemClick}
                onSearch={this.props.onSearch}
                placeholder="Search..."
                dataQaPrefix="clients-search"
              />
            </div>

            <GridTable>
              <div className="clients_body">
                {/*<GridTableRow scrollWidth={this.state.scrollWidth}>*/}

                <TableHead className="thead">
                  <div className="cell flex">
                    <div
                      className="flex items-center justify-right"
                      style={{ padding: '10px' }}
                      onClick={this.handleToggleAll}
                    >
                      <ArrowDown
                        className={`master_dropdown_arrow_position ${
                          !this.state.isCollapsed ? 'active' : ''
                        }`}
                      />
                    </div>
                    <div
                      onClick={() => this.changeSorting('displayName')}
                      className="inline-flex items-center underline cursor-pointer"
                    >
                      <span className="label_font">Client</span>
                      <IoIosArrowRoundDown
                        style={{
                          width: '20px',
                          height: '20px',
                          transform:
                            sort.column === 'displayName' && sort.value === 'DESC'
                              ? 'rotate(180deg)'
                              : '',
                        }}
                      />
                    </div>
                  </div>

                  {/*</GridTableCell>*/}
                  {/*<div className="text-right cell">*/}
                  {/*    <div*/}
                  {/*        // onClick={() => handleSortTable('estimateStatus')}*/}
                  {/*        className="inline-flex items-center underline cursor-pointer"*/}
                  {/*    >*/}
                  {/*        <span>Estimate</span>*/}
                  {/*        <IoIosArrowRoundUp*/}
                  {/*            style={{*/}
                  {/*                width: '20px',*/}
                  {/*                height: '20px',*/}
                  {/*                // transform: sort.position === 1 ? '' : 'rotate(180deg)',*/}
                  {/*                // visibility: sort && sort.column === 'estimateStatus' ? 'visible' : 'hidden',*/}
                  {/*            }}*/}
                  {/*        />*/}
                  {/*    </div>*/}
                  {/*</div>*/}
                  {/*</div>*/}
                  {/*<GridTableCell>*/}
                  <div style={{ paddingLeft: '6px' }} className="text-left cell flex">
                    <div
                      // onClick={() => this.changeSorting("billingType")}
                      className="inline-flex items-center cursor-pointer"
                    >
                      <span className="label_font">Type</span>
                      {/*<IoIosArrowRoundDown*/}
                      {/*    style={{*/}
                      {/*        width: '20px',*/}
                      {/*        height: '20px',*/}
                      {/*        transform: sort.column === "billingType" && sort.value === "DESC" ? 'rotate(180deg)' : '',*/}
                      {/*    }}*/}
                      {/*/>*/}
                    </div>
                  </div>
                  <div style={{ paddingLeft: '6px' }} className="text-right cell flex">
                    <div className="inline-flex items-center cursor-pointer">
                      <span className="label_font">Email</span>
                    </div>
                  </div>
                  <div style={{ paddingLeft: '4px' }} className="text-right cell flex">
                    <div className="inline-flex items-center cursor-pointer">
                      <span className="label_font">Phone</span>
                    </div>
                  </div>
                  <div style={{ paddingLeft: '2px' }} className="text-right cell flex">
                    <div className="inline-flex items-center cursor-pointer">
                      <span className="label_font">Projects</span>
                    </div>
                  </div>
                  <div style={{ paddingLeft: '2px' }} className="text-right cell flex">
                    <div className="inline-flex items-center cursor-pointer">
                      <span className="label_font"></span>
                    </div>
                  </div>
                </TableHead>
                <GridTableBody id="grid-table-body" style={{ height: 'calc(100vh - 350px)' }}>
                  <Accordion
                    index={this.state.activeIndexes}
                    handleRowChoosed={this.handleRowChoosed}
                    items={list}
                    handleShowDotMenu={this.props.handleShowDotMenu}
                    handleDotMenuAction={this.props.handleDotMenuAction}
                    dotMenu={this.props.dotMenu}
                  />
                </GridTableBody>
              </div>
            </GridTable>
          </div>
        )}
      </Container>
    );
  }

  public renderRow(data: SortTableRowInfo, index: number, level: number = 0): JSX.Element {
    return (
      <>
        <SortTableRow
          handleShowDotMenu={this.props.handleShowDotMenu}
          handleDotMenuAction={this.props.handleDotMenuAction}
          dotMenu={this.props.dotMenu}
          key={data.id}
          data={data}
          level={level}
          onChoosed={this.handleRowChoosed}
        />
        {data.subList &&
          data.subList.map((sub) => {
            if (sub.billToParent === false) {
              return this.renderRow(
                {
                  ...sub,
                },
                index,
                level + 1
              );
            }
            return this.renderRow(
              {
                ...sub,
                email: this.props.list[index].email,
                cellPhone: this.props.list[index].cellPhone,
              },
              index,
              level + 1
            );
          })}
      </>
    );
  }

  private changeSorting = (key: string) => {
    const { onSortingChanged, sort } = this.props;
    onSortingChanged(sort.value === 'ASC' ? 'DESC' : 'ASC', key);
  };

  private handleResize = () => {
    const e = document.getElementById('grid-table-body');
    const e1: HTMLElement | null = document.getElementsByClassName('grid-table-row')[0] as any;
    let scrollWidth = 0;
    if (e && e1) {
      scrollWidth = e.offsetWidth - e1.offsetWidth;
    }
    this.setState({
      scrollWidth,
    });
  };

  private handleRowChoosed = (id: number) => {
    const e = document.getElementById('grid-table-body');
    const scrollTop = e ? e.scrollTop : undefined;
    this.props.onRowChoosed(id, scrollTop);
  };
}
